export const CONTACT_EMAIL = "yanis.djouahra38@gmail.com";
